import { render, staticRenderFns } from "./PermissionRow.vue?vue&type=template&id=72fea0bc&scoped=true"
import script from "./PermissionRow.vue?vue&type=script&lang=js"
export * from "./PermissionRow.vue?vue&type=script&lang=js"
import style0 from "./PermissionRow.vue?vue&type=style&index=0&id=72fea0bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fea0bc",
  null
  
)

export default component.exports